import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loading from './components/loading/Loading';
import Map from './components/map/map';
import Swal from 'sweetalert2';
import axios from 'axios';
import Carousel from "./components/carousel/carousel";
import { format } from 'date-fns';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { changeMetricUnit } from './services/redux/actions';
import { feet2ToMeter2, feetToMeter } from './constants/constants';
import Metatags from "../Metatags/Metatags";

const feetSelector = createSelector(
    store => store.feets,
    feets => feets
);

export default function GarageDetails() {
    const navigate = useNavigate();
    const location = useLocation();
    const id = decodeURIComponent(location.pathname.split('/garages-details/')[1]);
    const userType = useSelector(state => state.user.userType);

    const garageURL = `${window.location.origin}/garages-details/${id}`;
   

    // const profile_complete = useSelector(state => state.user.profile_complete);

    // useEffect(() => {
    //     if (profile_complete != true) {
    //         navigate('/edit_user');
    //         Swal.fire({
    //             icon: 'info',
    //             title: 'Please complete your profile first.',
    //         });
    //     }
    // }, [profile_complete]);

    // useEffect(() => {
    //     if  (userType != 'Owner') {
    //         navigate('/edit_user');
    //         Swal.fire({
    //             icon: 'info',
    //             title: 'A buyer don;t have permissions to add Garage.',
    //         });
    //     }
    // }, [userType]);


    const user = useSelector(state => state.user.uid);
    // const [showSampleContract, setShowSampleContract] = useState(false);
    const [sampleContract, setSampleContract] = useState();
    const [garageInsurance, setGarageInsurance] = useState();
    const [loading, setLoading] = useState(true);
    const [loadingText, setLoadingText] = useState('Loading, please wait...');
    const [item, setItem] = useState({});
    const [metricUnit, setMetricUnit] = useState('');
    const feets = useSelector(feetSelector);
    const dispatch = useDispatch();
    const [EmptyImages, setEmptyImages] = useState(false);
    const [imagesURLs, setImagesURLs] = useState([]);

    const [previewPDF, setPreviewPDF] = useState(null);
    const [previewPDFTwo, setPreviewPDFTwo] = useState(null);


    useEffect(() => {
        setMetricUnit(() => {
            if (feets)
                return 'ft';
            return 'm';
        })
    }, [feets]);

    useEffect(() => {
        async function getGarage() {
            const data = await axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetGaragebyId', id: id })
                .then(response => {
                    if (response.data.status === true) {
                        return response.data.data;
                    } else {
                        Swal.fire({
                            icon: 'info',
                            title: response.data.message,
                        });
                        navigate('/')
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });

            if (data.sampleContractURL) {
                setSampleContract(() => {
                    return process.env.REACT_APP_UPLOAD_URL + data.sampleContractURL;
                })
            }

            if (data.garageInsuranceURL) {
                setGarageInsurance(() => {
                    return process.env.REACT_APP_UPLOAD_URL + data.garageInsuranceURL;
                })
            }

            const urlsArray = data.garagePictures;
            const garagePicturesAngle = data.garagePicturesA;
            let imagesURL = [];

            if (urlsArray.length > 0) {
                urlsArray.forEach((element, index) => {
                    const timestamp = format(new Date(), 'MMddyyyyHis');
                    const rotatedImage = {
                        url: process.env.REACT_APP_UPLOAD_URL + element + '?timestamp=' + timestamp,
                        rotationAngle: garagePicturesAngle[index] ? garagePicturesAngle[index] : '', // Fix: Use index to access the corresponding rotation angle
                    };
                    setImagesURLs([...imagesURL, rotatedImage])
                    imagesURL = [...imagesURL, rotatedImage];
                });


            } else {
                imagesURL = [{
                    url: './assets/Images/garage-placeholder.png',
                    rotationAngle: 0, // Set a default rotation angle if needed
                }];
                setEmptyImages('There are no images for this garage');
            }

            console.log('imagesURL', imagesURL)
            setItem((prev) => (
                {
                    ...prev,
                    ...data,
                    imgs: imagesURL,
                }
            ));

            if (data) {
                setLoading(false);
            } else {
                setLoadingText("We couldn't find the garage, maybe it has been removed")
            }
        }

        if (id) {
            getGarage(id);
        } else {
            setLoadingText("We couldn't find the garage, maybe it has been removed")
        }
    }, [id]);


    function approveFun(key, ToggleValue) {
        // const originalUserStatus = ToggleValue;
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to ${ToggleValue ? 'disable' : 'enable'} this garage!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: `Yes, ${ToggleValue ? 'disable' : 'enable'} it!`
        }).then(async (result) => {
            if (result.value) {
                Swal.fire({
                    title: 'Updating, please wait',
                    html:
                        '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
                    showConfirmButton: false,
                    showCancelButton: false,
                    focusConfirm: false,
                });
                axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'UpdateGarageStatusByUser', status: !ToggleValue, id: key })
                    .then(response => {
                        Swal.fire(
                            'success',
                            response.data.message,
                            'success'
                        ).then(() =>
                            navigate(0)
                        )
                    })
                    .catch(error => {
                        Swal.fire(
                            'There were a problem',
                            error ? 'Error fetching data:' + error : 'Please, try again or contact SAGE Parents',
                            'error'
                        )
                        console.error('Error fetching data:', error);
                    });

            }
        })
    }



    const deleteGarage = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.value) {
                Swal.fire({
                    title: 'Deleting, please wait',
                    html:
                        '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
                    showConfirmButton: false,
                    showCancelButton: false,
                    focusConfirm: false,
                });
                await axios.post(`${process.env.REACT_APP_API_URL}`, {
                    action: 'DeleteGarage',
                    id: id,
                }).then(response => {
                    if (response.data.status === true) {
                        console.log('response.data.statustttttttt')
                        Swal.fire(
                            'Deleted!',
                            'Your garage has been deleted.',
                            'success'
                        ).then(() => {
                            navigate(`/garages`);
                        })
                    } else {
                        console.log('response.data.statusffffff')
                        Swal.fire(
                            'Error!',
                            response.data.message,
                            'error'
                        )
                    }
                })
                    .catch(error => {
                        Swal.fire(
                            'Error!',
                            'Error' + error,
                            'error'
                        )
                    });

            }
        })
    };


    function handleFeetConverterButton() {
        const reduxAction = changeMetricUnit(!feets);
        dispatch(reduxAction);
    }

    const [maplatlng, setMaplatlng] = useState();
    function handleShowMap(e) {
        e.preventDefault();
        const latlng = { coordinates: { latitude: item.lat, longitude: item.lon }, address: item.address }
        console.log('latlng', latlng)
        setMaplatlng(latlng);
        document.getElementById('imagePreviewModal').classList.add('show');
        document.getElementById('imagePreviewModal').style.display = 'block';
    }
    const closeModal = (event) => {
        event.preventDefault();
        // setPreviewImages([]);
        document.getElementById('imagePreviewModal').classList.remove('show');
        document.getElementById('imagePreviewModal').style.display = 'none';
    };

    function makeOffer() {
        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to make an offer for this garage?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'NO, cancel',
            confirmButtonText: 'YES!'
        }).then((result) => {
            if (result.value) {
                if (user !== 'none') {
                    navigate(`/offer/${id}`);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: `You need to be logged.`,
                    }).then(() => {
                        navigate('/login');
                    })
                }
            }
        })
    }


    const openPDFModal = (event) => {
        event.preventDefault();
        document.getElementById('pdfPreviewModal').classList.add('show');
        document.getElementById('pdfPreviewModal').style.display = 'block';
    };

    const closePDFModal = (event) => {
        event.preventDefault();
        document.getElementById('pdfPreviewModal').classList.remove('show');
        document.getElementById('pdfPreviewModal').style.display = 'none';
    };

    const openPDFTwoModal = (event) => {
        event.preventDefault();
        document.getElementById('pdfPreviewModalTwo').classList.add('show');
        document.getElementById('pdfPreviewModalTwo').style.display = 'block';
    };

    const closePDFTwoModal = () => {
        document.getElementById('pdfPreviewModalTwo').classList.remove('show');
        document.getElementById('pdfPreviewModalTwo').style.display = 'none';
    };
     const handleCopy = () => {
        if (item && item.description) {
            navigator.clipboard.writeText(item.description).then(() => {
                // alert('Garage description copied to clipboard!');
            }).catch((err) => {
                console.error('Failed to copy: ', err);
            });
        } else {
            alert('No description available to copy.');
        }
    };

  const handleCraigslist = () => {
    if (item && item.description) {
        const garageURL = `${window.location.origin}/garages-details/${id}`;
        const finalText = `${item.description}\n\n` +
            `<a href="${garageURL}" target="_blank">Click here</a>`;

        navigator.clipboard.writeText(finalText).then(() => {
            // alert('Formatted text copied for Chicholost!');
        }).catch((err) => {
            console.error('Failed to copy: ', err);
        });
    } else {
        alert('No description available to copy.');
    }
};
  const handleCraigslistShare = () => {
        handleCraigslist();
        const craigslistUrl = "https://post.craigslist.org/c/chicago";
          Swal.fire(
                            'Details Copied',
                            'We have copied the garage details. You can paste the details on Craigslist if you like',
                            'info'
                        ).then(() =>
        window.open(craigslistUrl, '_blank', 'width=600,height=400')
                        )
    };


    const handleFacebookShare = () => {
        console.log('imagesURLs[0]',imagesURLs?.[0]?.url)
        handleCopy();
        const url = encodeURIComponent(`https://garagexy.com${location.pathname}`);
        const quote = encodeURIComponent(`Check out this garage: ${item.rentalRate} - ${item.description}`);
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${quote}`;
        Swal.fire(
                            'Details Copied',
                            'We have copied the garage details. You can paste the details on Facebook if you like',
                            'info'
                        ).then(() =>
        window.open(facebookUrl, '_blank', 'width=600,height=400')
                        )

        console.log('quote', quote)
    };

    return (
        <>
            <Metatags
                title={`Garage in ${item.state}, ${item.zipcode}`}
                description={`find garages in ${item.state}, ${item.zipcode}`}
                keywords={`rent garage space,secure garage, best garages, ${item.state}, ${item.zipcode}`}
                url={`https://garagexy.com${location.pathname}`}
                image={imagesURLs?.[0]?.url}
            />
            <section className="page-content sec-padding">
                <div className="container-fluid">
                    {
                        loading ?
                            <Loading text={loadingText} />
                            :
                            <div className="page-content-details">


                                <div className="sec-title row">
                                    <div className="col-md-3 text-start">
                                        <h3>Garage Details</h3>
                                    </div>
                                    <div className="col-md-6 text-center text-danger">
                                        {/* {item.today_date} {item.end_date} */}
                                        {item && item.dealClosed === 1 && item.today_date < item.end_date &&
                                            <h5>Please ensure that this garage is available before renting it. It is currently booked until further notice.
                                                The garage is reserved from <b>{item.start_date}</b> to <b>{item.end_date}</b>.</h5>
                                        }
                                    </div>
                                    {/* <div className="col-md-3 d-flex" >
                                    {item.ownerID === user &&
                                        <Link className='btn btn-primary btn-lg'
                                            to={`/garage-edit/${id}`}
                                        >Edit Garage </Link>
                                    }
                                    <p>POST ON </p>
                                </div> */}
                                    <div className="col-md-3 d-flex align-items-center gap-2">
                                        {item.ownerID === user && (
                                            <Link className='btn btn-primary btn-lg' to={`/garage-edit/${id}`}>
                                                Edit Garage
                                            </Link>
                                        )}
                                        <div className='mx-4 align-items-center gap-2'>
                                            <p className="mb-0 me-2" style={{ fontSize: '10px', fontWeight: '700' }} >POST YOUR GARAGE</p>

                                            <div className='d-flex align-items-center gap-2'>
                                                {/* Facebook Share Icon */}
                                                <a
                                                    onClick={handleFacebookShare}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title="Post on Facebook"
                                                >
                                                    <img
                                                        src={`${process.env.REACT_APP_PUBLIC_URL}assets/images/facebook.png`}
                                                        alt="Facebook Logo"
                                                        style={{ height: '30px', width: '100%', objectFit: 'contain' }}
                                                    />
                                                </a>

                                                {/* Craigslist Link */}
                                                <a
                                                    onClick={handleCraigslistShare}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title="Post on Craigslist"
                                                >
                                                    <img
                                                        src={`${process.env.REACT_APP_PUBLIC_URL}assets/images/iconchiaglist.png`}
                                                        alt="Craigslist Logo"
                                                        style={{ height: '35px', width: '100%', objectFit: 'contain' }}
                                                    />
                                                </a>
                                            </div>

                                        </div>
                                    </div>


                                </div>

                                <div className='sales-items'>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div style={{ minHeight: '300px' }}>
                                                {item && item.description}
                                            </div>
                                            <div className='d-flex mb-3' id='details'>
                                                <div className='garage__info__camp__label'>
                                                    <i className='fa fa-dollar strong'></i>
                                                    <span className='strong'>Rental Rate: </span>
                                                </div>
                                                <div className='garage__info__camp__description'> ${item && item.rentalRate}</div>
                                            </div>
                                            <div className='btn-toolbar'>
                                                {sampleContract ?
                                                    <button onClick={openPDFModal} className='btn btn-primary btn-lg' target="_blank" rel="noopener noreferrer">Sample Contract</button>
                                                    :
                                                    <button onClick={() => Swal.fire({ icon: 'question', title: 'There\'s no sample contract in this garage' })} className='btn btn-primary' >Sample contract</button>
                                                }
                                                {garageInsurance ?
                                                    <button onClick={openPDFTwoModal} className='btn btn-primary btn-lg' target="_blank" rel="noopener noreferrer">Garage Insurance</button>
                                                    :
                                                    <button onClick={() => Swal.fire({ icon: 'question', title: 'There\'s no sample contract in this garage' })} className='btn btn-primary' >Garage Insurance</button>
                                                }
                                                {/* {item && item.dealClosed !== 1 && item.ownerID !== user && (  */}
                                                {item && item.ownerID !== user && userType == 'Tenant' && (
                                                    item.rentButton && item.rentButton > item.today_date ?
                                                        '' :
                                                        < button className='btn btn-primary btn-lg' onClick={makeOffer}>Rent Garage</button>
                                                )}
                                            </div>
                                        </div>
                                        <div className='col-md-6 position-relative'>

                                            {/* <div style={{ height: "300px", margin: "20px 0px 40px 0px" }}>
                                        <CarouselSlick image={imagesURLs} />
                                    </div> */}
                                            {imagesURLs &&
                                                <Carousel images={imagesURLs} />
                                            }
                                        </div>



                                        <div className='col-md-8 m-auto pt-4'>
                                            <div className='text-end mb-2'>
                                                <button onClick={handleFeetConverterButton} className="btn btn-secondary btn-lg"> {`Change to ${feets ? 'meters' : 'feet'}`} </button>
                                            </div>

                                            <table className='table garagedetailTable'>
                                                <tbody>
                                                    <tr>
                                                        <td><i className='fa fa-dollar strong'></i></td>
                                                        <td><span className='strong'>Rental Rate:</span></td>
                                                        <td> ${item && item.rentalRate}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td><i className='fa fa-dollar strong'></i></td>
                                                        <td><span className='strong'>Zillow Suggested Rental:</span></td>
                                                        <td> <small className='small'>High: </small>
                                                            <span>${item && item.rentalRate}</span></td>
                                                        <td> <small className='small'>Low: </small>
                                                            <span>${item && item.rentalRate}</span></td>

                                                        <td> <Link to='https://www.Zillow.com/research/data' className='text-primary' target='_blank'>Zillow Website</Link></td>
                                                    </tr>
                                                    <tr>
                                                        <td><i className='fa fa-location-arrow strong'></i></td>
                                                        <td><span className='strong'>Address: </span></td>
                                                        <td> <div>{user !== 'none' ? `${item.address} , ${item.city}, ${item.state}` : 'You need to be logged to access this direction'}</div>

                                                        </td>
                                                        <td></td>
                                                        <td>
                                                            {user !== 'none' &&
                                                                <button className='btn btn-primary' onClick={handleShowMap}>
                                                                    Map
                                                                </button>
                                                            }
                                                            <div className="modal fade" id="imagePreviewModal" tabIndex="-1" role="dialog">
                                                                <div className="modal-dialog modal-lg" role="document">
                                                                    <div className="modal-content">
                                                                        <div className="modal-header">
                                                                            <h5 className="modal-title">Map Preview</h5>
                                                                            <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={closeModal}>
                                                                                <span aria-hidden="true"></span>
                                                                            </button>
                                                                        </div>
                                                                        <div className="modal-body" style={{ height: "500px", overflowY: "auto" }}>

                                                                            <div className="row align-items-center">
                                                                                {maplatlng &&
                                                                                    <Map
                                                                                        type="point"
                                                                                        extraInfo={maplatlng}
                                                                                    />
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                        <div className="modal-footer">
                                                                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closeModal}>Done</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><i className='fa fa-location-arrow strong'></i></td>
                                                        <td> <span className='strong'>Neighborhood: </span></td>
                                                        <td>{user !== 'none' ? item.neighborhood : ''}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <td><i className='fa fa-location-arrow strong'></i></td>
                                                        <td> <span className='strong'>Zipcode: </span></td>
                                                        <td>{user !== 'none' ? item.zipcode : ''}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <td><i className='fa fa-home strong'></i></td>
                                                        <td><span className='strong'>Dimensions: </span></td>
                                                        <td>   <div>
                                                            <small className='small'>length: </small>
                                                            <span>{item && `${feets ? item.length : feetToMeter(item.length, true)} ${metricUnit}`}</span>
                                                        </div>

                                                            <div>
                                                                <small className='small'>width: </small>
                                                                <span>{item && `${feets ? item.width : feetToMeter(item.width, true)} ${metricUnit}`}</span>
                                                            </div>

                                                            <div>
                                                                <small className='small'>area: </small>
                                                                <span>{item && `${feets ? (item.width * item.length) : feet2ToMeter2((item.width * item.length), true)} ${metricUnit}²`}</span>
                                                            </div></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>


                                                    <tr>
                                                        <td><i className='fa fa-lock strong'></i></td>
                                                        <td><span className='strong'>Main Door:</span></td>
                                                        <td>     <div>
                                                            <small className='small'>height: </small>
                                                            <span>{item && `${feets ? item.mainDoorHeight : feetToMeter(item.mainDoorHeight, true)} ${metricUnit}`}</span>
                                                        </div>
                                                            <div>
                                                                <small className='small'>width: </small>
                                                                <span>{item && `${feets ? item.mainDoorWidth : feetToMeter(item.mainDoorWidth, true)} ${metricUnit}`}</span>
                                                            </div></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <td><i className='fa fa-lock strong'></i></td>
                                                        <td><span className='strong'>Connected to the house:</span></td>
                                                        <td>{item && item.isConnectedToHouse == 'true' ? 'Yes' : 'No'}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <td><i className='fa fa-lock strong'></i></td>
                                                        <td><span className='strong'>Door Opener:</span></td>
                                                        <td>{item && item.doorOpener == 'true' ? 'Yes' : 'No'}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>


                                                    <tr>
                                                        <td><i className='fa fa-dollar strong'></i></td>
                                                        <td><span className='strong'>Drywalled:</span> </td>
                                                        <td>{item && item.drywalled == 'true' ? 'Yes' : 'No'}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>


                                                    <tr>
                                                        <td><i className='fa fa-lock strong'></i></td>
                                                        <td><span className='strong'>Electrical Outlets:</span></td>
                                                        <td> <div>
                                                            <small className='small'>110V: </small>
                                                            <span>{(item && item.electricalOutlets110V && item.electricalOutlets110V == 'true') ? 'true' : 'false'}</span>
                                                        </div>

                                                            <div>
                                                                <small className='small'>220V: </small>
                                                                <span>{(item && item.electricalOutlets220V && item.electricalOutlets220V == 'true') ? 'true' : 'false'}</span>
                                                            </div></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <td><i className='fa fa-plug strong'></i></td>
                                                        <td><span className='strong'>Other Storage:</span></td>
                                                        <td>{item && item.otherStorage == 'true' ? 'Yes' : 'No'}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>


                                                    <tr>
                                                        <td><i className='fa fa-dollar strong'></i></td>
                                                        <td><span className='strong'>Side Door:</span> </td>
                                                        <td>{item && item.sideDoor == 'true' ? 'Yes' : 'No'}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>


                                                    <tr>
                                                        <td><i className='fa fa-windows strong'></i></td>
                                                        <td><span className='strong'>Windows:</span></td>
                                                        <td>{item && item.windows == 'true' ? 'Yes' : 'No'}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>


                                                    <tr>
                                                        <td><i className='fa fa-snowflake-o strong'></i></td>
                                                        <td><span className='strong'>Heated / AC:</span></td>
                                                        <td>{item && (item.heated || 'No')}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>


                                            <div className='garage__info__camp__description'>
                                                {item.ownerID === user &&
                                                    <>
                                                        <span className='btn btn-danger btn-lg me-2' onClick={() => deleteGarage(id)}>
                                                            Delete Garage
                                                        </span>
                                                        <button
                                                            className={`btn btn-${item.status === 1 ? "primary" : "secondary"} btn-lg`}
                                                            onClick={() => approveFun(id, item.status === 1 ? true : false)} >
                                                            {item.status === 1 ? "Enabled" : "Disabled"}
                                                        </button>
                                                    </>
                                                }
                                            </div>

                                            {sampleContract &&
                                                <div className="modal fade" id="pdfPreviewModal" tabIndex="-1" role="dialog">
                                                    <div className="modal-dialog modal-xxl" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title">Sample Contract Preview</h5>

                                                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={closePDFModal}>
                                                                    <span aria-hidden="true"></span>
                                                                </button>
                                                            </div>
                                                            <div className="modal-body">
                                                                <embed src={sampleContract} type="application/pdf" width="100%" height="500px" />
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closePDFModal}>Close</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {garageInsurance &&
                                                <div className="modal fade" id="pdfPreviewModalTwo" tabIndex="-1" role="dialog">
                                                    <div className="modal-dialog modal-xxl" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title">Garage Insurance Preview</h5>

                                                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={closePDFTwoModal}>
                                                                    <span aria-hidden="true"></span>
                                                                </button>
                                                            </div>
                                                            <div className="modal-body">
                                                                <embed src={garageInsurance} type="application/pdf" width="100%" height="500px" />
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closePDFTwoModal}>Close</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }


                                        </div>
                                    </div>
                                </div>
                            </div>

                    }
                </div>
            </section >

        </>
    )
}
